import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export function openRazorpayCheckout({ order, prefill, onVerified, onDismiss }) {
  if (!window.Razorpay) {
    toast.error("Payment system failed to load. Please refresh and try again.");
    onDismiss?.();
    return;
  }
  const isSubscription = order.mode === "subscription" && order.subscription_id;
  const opts = {
    key: order.key_id,
    name: "MathWhiz Beads",
    description: isSubscription ? "Monthly membership (auto-debit)" : "Monthly membership fee",
    prefill,
    theme: { color: "#FF5A5F" },
    handler: async (resp) => {
      try {
        await api.post("/payments/verify", {
          user_id: order.user_id,
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_subscription_id: resp.razorpay_subscription_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        onVerified?.();
      } catch (err) {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Payment verification failed. Contact your teacher.");
        onDismiss?.();
      }
    },
    modal: { ondismiss: () => onDismiss?.() },
  };
  if (isSubscription) {
    opts.subscription_id = order.subscription_id;
  } else {
    opts.order_id = order.order_id;
    opts.amount = order.amount;
    opts.currency = order.currency;
  }
  const rzp = new window.Razorpay(opts);
  rzp.on("payment.failed", (resp) => {
    toast.error(resp?.error?.description || "Payment failed. Please try again.");
    const pid = resp?.error?.metadata?.payment_id;
    if (pid && order.user_id) {
      api.post("/payments/failed", {
        user_id: order.user_id,
        razorpay_payment_id: pid,
        razorpay_order_id: resp?.error?.metadata?.order_id,
        reason: resp?.error?.description,
      }).catch(() => {});
    }
  });
  rzp.open();
}

export function fmtINR(paise) {
  return `₹${(paise / 100).toLocaleString("en-IN")}`;
}

export function fmtMoney(minorAmount, currency = "INR") {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format((minorAmount || 0) / 100);
  } catch {
    return `${currency} ${((minorAmount || 0) / 100).toFixed(0)}`;
  }
}

export const COUNTRIES = [
  { code: "IN", name: "India" },
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "SG", name: "Singapore" },
  { code: "AU", name: "Australia" },
  { code: "CA", name: "Canada" },
  { code: "DE", name: "Germany" },
  { code: "FR", name: "France" },
  { code: "NZ", name: "New Zealand" },
  { code: "OTHER", name: "Other" },
];
